import React from 'react';

interface XPRewardCardProps {
  isLoading?: boolean;
  value?: number;
  details?: { label: string; value: string | number }[];
}

export const XPRewardCard: React.FC<XPRewardCardProps> = ({
  isLoading = false,
  value,
  details = [],
}) => {
  if (isLoading) {
    return (
      <section className="flex flex-col p-4 rounded-lg border flex-1 min-w-[200px] min-h-[100px] bg-blue-50 border-blue-200 max-w-[536px]">
        <div className="flex justify-center items-center flex-1">
          <div className="animate-spin rounded-full w-6 h-6 border-2 border-blue-600 border-t-transparent"></div>
        </div>
      </section>
    );
  }

  if (value === undefined) {
    return null;
  }

  return (
    <section className="flex flex-col p-4 rounded-lg border flex-1 min-w-[200px] min-h-[100px] bg-blue-50 border-blue-200 max-w-[536px]">
      <div className="flex flex-col justify-center flex-1">
        <div className="flex gap-2 items-center justify-center text-blue-600">
          <img
            alt=""
            loading="lazy"
            src={require('../assets/icons/xp-coins.svg')}
            className="w-5 h-5"
          />
          <div className="text-xl font-bold">+{value} XP</div>
        </div>

        {details?.length > 0 && (
          <div className="mt-2 space-y-1">
            {details.map((detail, idx) => (
              <div
                key={idx}
                className="flex justify-between text-sm text-blue-800"
              >
                <span>{detail.label}</span>
                <span className="font-semibold text-blue-600">
                  +{detail.value} XP
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
